import * as signalR from "@microsoft/signalr";
import { getClientConfig } from "../../config/clientConfig";
const user = JSON.parse(localStorage.getItem("user") || "{}");
const clientConfig = getClientConfig();
export const connection = new signalR.HubConnectionBuilder()
  .withUrl(clientConfig.signalR, {
    accessTokenFactory: () => user?.userId?.toString(), // REQUIRED
  })
  .withAutomaticReconnect()
  .build();

export const startConnection = async () => {
  if (connection.state === "Connected") return;

  try {
    await connection.start();
    console.log("SignalR Connected");
  } catch (err) {
    console.error("Connection failed:", err);
    setTimeout(startConnection, 5000);
  }
};


// export const connection = new signalR.HubConnectionBuilder()
//   .withUrl("https://dev-api.iyvault.iykons.com/processingHub", {
//     accessTokenFactory: () => user?.userId?.toString(), // REQUIRED
//   })